import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";


export const AllPrivacyPolicy = createAsyncThunk(
  "/website/footer/privacy-policy",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllPrivacyPolicy);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetConcentTerms = createAsyncThunk(
  "/website/footer/concent-and-term",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.GetConcentTerms);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllTermsCondition = createAsyncThunk(
  "/website/footer/terms-and-condition",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllTermsCondition);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllShippingAndDeliveryPolicy = createAsyncThunk(
  "/website/footer/shipping-and-delivery-policy",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllShippingAndDeliveryPolicy);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllDonationCancellation = createAsyncThunk(
  "/website/footer/donation-cancellation-and-refund-policy",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllDonationCancellation);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllAboutUs = createAsyncThunk(
  "/website/footer/about-us",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllAboutUs);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllAppsetup = createAsyncThunk(
  "/website/footer/app-setup",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllAppsetup);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllSocialLink = createAsyncThunk(
  "/website/footer/social-link",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllSocialLink);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllFaq = createAsyncThunk(
  "/website/footer/faq",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Footers.AllFaq);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




export const Slice = createSlice({
  name: "footer",
  initialState: {

    terms_condition: [],
    cencent_terms: {},
    privacy_policy: [],
    shipping_delivery_policy: [],
    donation_cancellation: [],
    all_faq: [],
    about_us: [],
    app_setup: [],
    all_social_links: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(AllFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faq = action.payload || [];
      })
      .addCase(AllFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllAppsetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAppsetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.app_setup = action.payload || [];
      })
      .addCase(AllAppsetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(AllSocialLink.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSocialLink.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_social_links = action.payload || [];
      })
      .addCase(AllSocialLink.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.privacy_policy = action.payload || [];
      })
      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetConcentTerms.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetConcentTerms.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.cencent_terms = action.payload || [];
      })
      .addCase(GetConcentTerms.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllTermsCondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermsCondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.terms_condition = action.payload || [];
      })
      .addCase(AllTermsCondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllShippingAndDeliveryPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllShippingAndDeliveryPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.shipping_delivery_policy = action.payload || [];
      })
      .addCase(AllShippingAndDeliveryPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllDonationCancellation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDonationCancellation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.donation_cancellation = action.payload || [];
      })
      .addCase(AllDonationCancellation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllAboutUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAboutUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.about_us = action.payload || [];
      })
      .addCase(AllAboutUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
